import React from "react";
import { Box } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

/** Vehicle (truck) entity icon, in the same tile as BusIcon / BatteryIcon. */
export const TruckIcon = (props) => (
  <Box
    sx={{
      width: "32px",
      height: "32px",
      background: "#EEEEEE",
      borderRadius: "6.2px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <LocalShippingIcon sx={{ fontSize: "20px", color: "#8F8F8F", ...props }} />
  </Box>
);
